/* eslint-disable indent */

export default (item, instantsearch) => {
  const heading = item.locale === 'en' ? `${instantsearch.highlight({
    attribute: 'name',
    hit: item,
  })}` : `${instantsearch.highlight({
    attribute: 'name_zh',
    hit: item,
  })}`

  if (item.locale === 'zh') {
    /* This next line simply checks if we are in the global search or Voices-only search. Global search doesn't have a Service field attached. */
    var subheading = item.service ? `<p class="tease-type">
    ${instantsearch.highlight({
      attribute: 'type_zh.0',
      hit: item,
    })}
    </p>` : `<p class="tease-type">${item.type_zh}</p>`
  } else {
    /* This next line simply checks if we are in the global search or Voices-only search. Global search doesn't have a Service field attached. */
    var subheading = item.service ? `<p class="tease-type">
    ${instantsearch.highlight({
      attribute: 'type.0',
      hit: item,
    })}
    </p>` : `<p class="tease-type">${item.type}</p>`
  }

  const link = item.locale === 'en' ? `${item.link}` : `${item.link_zh}`;

  const image = item.image ? `<img src="${item.image}" class="tease-img" alt="${item.title}" />` : '';

  return `<article class="tease tease--voices">
    <a href="${link}" class="tease-link">
      <div class="tease-art">
        <figure class="tease-figure">
          ${image}
        </figure>
      </div>
      <div class="tease-content">
        <h1 class="tease-title">${heading}</h1>
        ${subheading}
      </div>
    </a>
  </article>`
};
